import {
    NAV_ITEM_TYPE_TITLE,
    NAV_ITEM_TYPE_ITEM,
} from 'constants/navigation.constant'

const navigationConfig = [
    {
        key: 'tournaments',
        path: '',
        title: 'Pages',
        translateKey: 'nav.pages',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [],
        subMenu: [
            {
                key: 'tournaments.all',
                path: '/tournaments',
                title: 'All Tournaments',
                translateKey: 'nav.tournaments',
                icon: 'globe',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
            {
                key: 'tournaments.topteams',
                path: '/topteams',
                title: 'Top Teams',
                translateKey: 'nav.topteams',
                icon: 'topteams',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            },
            {
                key: 'tournaments.teams',
                path: '/teams',
                title: 'Find Teams',
                translateKey: 'nav.findteams',
                icon: 'teams',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
            }
        ],
    },
    {
      key: 'info',
      path: '/info',
      title: 'Info',
      translateKey: 'nav.info',
      icon: 'info',
      type: NAV_ITEM_TYPE_ITEM,
      authority: [],
      subMenu: [],
    },
    {
        key: 'faq',
        path: '/faq',
        title: 'FAQ',
        translateKey: 'nav.faq',
        icon: 'faq',
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
    },
];

export default navigationConfig
